var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61559 7.66668V5.66675H26.3848V7.66668H5.61559ZM5.66689 26.3333V18.3333H4.17969V16.3334L5.61559 9.66675H26.3848L27.8207 16.3334V18.3333H26.3335V26.3333H24.3336V18.3333H18.3335V26.3333H5.66689ZM7.66682 24.3334H16.3336V18.3333H7.66682V24.3334ZM6.22065 16.3334H25.7797L24.7618 11.6667H7.23862L6.22065 16.3334Z",
    fill: "#F7F7F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.3aba88c7f559c0b222e26ca344a07653.svg";
export { ForwardRef as ReactComponent };